const TrustStrip = () => {
  return (
    <section className="py-12 bg-muted/50">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="text-center space-y-4">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">
            Trusted by independent professionals who take their business seriously.
          </h2>
          <div className="flex flex-wrap items-center justify-center gap-3 text-sm md:text-base text-muted-foreground">
            <span>Freelance Designers</span>
            <span className="text-primary">•</span>
            <span>Indie Developers</span>
            <span className="text-primary">•</span>
            <span>Consultants</span>
            <span className="text-primary">•</span>
            <span>Solo Agencies</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
